import { downloadForm1099NecTrack1099Csv } from "@api/form1099NecReport.api";
import { saveBlobResponse, useFileDownload } from "@lib/fileDownload";
import { useScope } from "@state/scopeContext.lib";

interface DownloadParams {
    taxYear: number;
    entityId: number | undefined;
}

export function useForm1099NecTrack1099Download({
    taxYear,
    entityId,
}: DownloadParams) {
    const { workspaceId } = useScope();

    return useFileDownload(async () => {
        if (!workspaceId || entityId === undefined) {
            return;
        }
        const response = await downloadForm1099NecTrack1099Csv({
            workspaceId,
            taxYear,
            entityId,
        });
        saveBlobResponse(response, `${taxYear} 1099-NEC Track1099.csv`);
    });
}
